export interface RangeEstimationContent {
  title: string
  type: string
  boldText?: string
  description?: string
  paragraph1?: string
  paragraph2?: string
  footer?: string
}

// Content configuration for different range types
export const rangeContent: Record<string, RangeEstimationContent> = {
  default: {
    type: 'default',
    title: 'How is range estimated?',
    paragraph1:
      'Estimated range is calculated using WLTP combined values when available. If not, other certified test values (TEH, TEL, or NEDC) are used.',
    paragraph2:
      'Actual range will depend on the size and age of your battery, weather conditions, how you drive the car and the route you take.',
  },
  nedc: {
    type: 'nedc',
    title: 'Range estimation',
    boldText: 'This car is measured using the NEDC standard.',
    description:
      'NEDC (New European Driving Cycle) is an older testing process for measuring car fuel economy, electric driving range and emissions.',
    footer: 'Real world values may differ for used cars.',
  },
  wltp: {
    type: 'wltp',
    title: 'Range estimation',
    boldText: 'This car is measured using the WLTP standard.',
    description:
      'WLTP (Worldwide Harmonised Light Vehicle Test Procedure) is a testing process for measuring new car fuel economy, electric driving range and emissions',
    footer: 'Real world values may differ for used cars.',
  },
}
